import { FC, useEffect, useRef, useState } from 'react';
import { useSearchBox } from 'react-instantsearch';

import { InlineSearchField } from '../../shared/components';

const DEBOUNCE_MS = 300;

export const CollectionSearchField: FC = () => {
  const { query, refine } = useSearchBox();
  const [value, setValue] = useState(query);
  const timerRef = useRef<number>();

  useEffect(() => {
    setValue(query);
  }, [query]);

  useEffect(
    () => () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    },
    []
  );

  const onChange = (next: string) => {
    setValue(next);

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = window.setTimeout(() => {
      refine(next);
    }, DEBOUNCE_MS);
  };

  const onClear = () => {
    setValue('');

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    refine('');
  };

  return (
    <InlineSearchField
      value={value}
      onChange={onChange}
      onClear={onClear}
      placeholder={theme.locales.searchInCollectionPlaceholder}
    />
  );
};
